module.exports = __webpack_public_path__ + "static/media/ticsante.dc77df5e.jpg";